import { apiClient } from "../api"
import { stringifyParams } from "../utils/api"
import { DTO_Collisions, CollisionsParam, DTO_MobileProfile, DTO_SimpleMobile, DTO_SystemMobile, DTO_TrailHistory, TrailHistoryParam } from "./types/mobiles"

const SYSTEM_MOBILE = '/system/mobile/'
const MOBILE_PROFILE = '/mobileprofile/'

export const getMobileList = (params?: any): Promise<DTO_SimpleMobile[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params?.queryKey?.[0] ?? {})
  const promise = ac.get(`/mobile/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

/**
 * Fetch trail history on mobiles
 * @param {TrailHistoryParam} params  
 * @returns {DTO_TrailHistory}
 */
export const getTrailHistory = (params: TrailHistoryParam): Promise<DTO_TrailHistory> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`/trailhistory/?${queryStr}`)
    .then(res => res.data)
  return promise
}

export const getCollisions = (params: CollisionsParam): Promise<DTO_Collisions> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`/mobilecrashdata/?${queryStr}`)
    .then(res => res.data)
  return promise
}

export const getSystemMobiles = (params?: any): Promise<DTO_SystemMobile[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params?.queryKey?.[0] ?? {})
  const promise = ac.get(`${SYSTEM_MOBILE}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getSystemMobile = (mobileid: number): Promise<DTO_SystemMobile> => {
  const ac = apiClient()
  const promise = ac.get(`${SYSTEM_MOBILE}${mobileid}/`)
    .then(res => res.data)
  return promise
}

export const updateMobile = (id: number, data: DTO_SystemMobile): Promise<DTO_SystemMobile> => {
  const ac = apiClient()
  const promise = ac.put(`${SYSTEM_MOBILE}${id}/`, data).then(res => res.data)
  return promise
}

export const getMobileProfile = (mobileid: number): Promise<DTO_MobileProfile> => {
  const ac = apiClient()
  const promise = ac.get(`${MOBILE_PROFILE}${mobileid}/`)
    .then(res => res.data)
  return promise
}
